<nav class="navbar navbar-expand-lg navbar-light sticky-top navbarStyle" style="z-index: 500;">
  <div class="container-fluid navbar-container">
    <!-- Left Section: Sidebar Toggle + Brand -->
    <div class="navbar-left d-flex align-items-center">
      <!-- Sidebar toggle -->
      <button
        mat-icon-button
        type="button"
        class="sidebar-toggle-btn"
        aria-label="Toggle sidebar navigation"
        (click)="toggleSidebar()">
        <mat-icon>menu</mat-icon>
      </button>

      <!-- Brand Logo + Name -->
      <a class="brand-section d-flex align-items-center" [routerLink]="['/dashboard']">
        <img
          class="navBrand"
          [src]="brandLogo"
          [attr.alt]="brandAlt"
          (error)="handleBrandLogoError($event)" />
        <div class="brand-text">
          <small
            class="account-name"
            *ngIf="accountName">
            {{ accountName }}
          </small>
        </div>
      </a>
    </div>

    <!-- Right Section: User Info + Menu -->
    <div class="navbar-right d-flex align-items-center">
      <!-- User Info (Desktop) -->
      <div class="user-info-desktop d-none d-md-flex align-items-center" *ngIf="displayName">
        <div class="user-details">
          <span class="user-name">
            {{ displayName }}
          </span>
        </div>
      </div>

      <!-- User Avatar Dropdown -->
      <div class="user-menu-dropdown">
        <button
          mat-icon-button
          type="button"
          class="user-avatar-btn"
          id="navbarDropdownMenuLink"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          aria-label="Open user menu">
          <div class="avatar-wrapper">
            <img
              alt="User avatar"
              class="user-avatar"
              [src]="profilepic ? (storageUrl + '/' + profilepic) : 'assets/Images/userLogo.png'"
              (error)="handleImageError($event)">
            <div class="avatar-status"></div>
          </div>
        </button>
        <div
          class="dropdown-menu dropdown-menu-end user-dropdown-menu"
          aria-labelledby="navbarDropdownMenuLink">
          <!-- User Info in Dropdown (All Screens) -->
          <div class="dropdown-header">
            <div class="dropdown-avatar-wrapper">
              <img
                alt="User avatar"
                class="dropdown-avatar"
                [src]="profilepic ? (storageUrl + '/' + profilepic) : 'assets/Images/userLogo.png'"
                (error)="handleImageError($event)">
              <div class="dropdown-avatar-status"></div>
            </div>
            <div class="dropdown-user-info">
              <div
                class="dropdown-user-name"
                *ngIf="displayName">
                {{ displayName }}
              </div>
              <div
                class="dropdown-user-role-wrapper"
                *ngIf="userRole">
                <span class="dropdown-user-role-badge">{{ userRole }}</span>
              </div>
            </div>
          </div>
          
          <!-- Dropdown Divider -->
          <div class="dropdown-divider"></div>
          
          <!-- Profile Option -->
          <button
            type="button"
            class="dropdown-item"
            (click)="navigateToProfile()">
            <mat-icon>person</mat-icon>
            <span>My Profile</span>
          </button>
          
          <!-- Settings Option -->
          <button
            type="button"
            class="dropdown-item"
            (click)="navigateToSettings()">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </button>
          
          <!-- Divider -->
          <div class="dropdown-divider"></div>
          
          <!-- Logout Option -->
          <button
            type="button"
            class="dropdown-item dropdown-item-danger"
            (click)="logOut()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
